import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Box, Divider, IconButton } from '@mui/material';
import React from 'react';
/**
 * Renders the action section of a Card, including a vertical divider and an icon button.
 *
 * @param {CardActionProps} props - Props for the CardAction component.
 * @param {string} [props.ariaLabel] - ARIA label for the action button, used for accessibility.
 * @param {React.ReactNode} [props.icon] - Optional icon to render inside the button; defaults to AddCircleOutlineIcon if not provided.
 * @param {() => void} [props.onClick] - Callback function triggered when the action icon button is clicked.
 *
 * @returns {React.ReactElement} The rendered CardAction component.
 */
export const CardAction = (props) => {
    return (React.createElement(Box, { sx: {
            alignSelf: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: 'auto',
        }, "data-test": 'action' },
        React.createElement(Divider, { orientation: 'vertical', flexItem: true, variant: 'middle' }),
        React.createElement(Box, { sx: {
                px: 1,
            } },
            React.createElement(IconButton, { color: 'primary', "aria-label": props.ariaLabel, onClick: props.onClick }, props.icon ? props.icon : React.createElement(AddCircleOutlineIcon, null)))));
};
